<template>
  <div class="animated fadeIn">
    <br />
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Costo Variable Mínimo</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
            <b-row class="my-1">
              <b-col sm="2">
                <label>Póliza</label>
              </b-col>
              <b-col sm="2">
                <b-input-group> 
                    <b-form-input 
                        type="number" 
                        v-model="datosFormulario.poliza"
                        @change="consulta_poliza()"
                        >
                    </b-form-input>
                </b-input-group>
              </b-col>
              <b-col sm ="2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionAse"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.NombreAseg"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>
            
            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Ejecutivos</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valEjecutivos"
                      v-model="datosFormulario.ejecutivo">
                  </b-form-select>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.ejecutivo }}</span>
              </b-col>
            </b-row>

                        <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Asistentes</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valAsistentes"
                      v-model="datosFormulario.asistente">
                  </b-form-select>
                  <span class="error-validacion-campo">{{ mensajeValidacionCampo.ejecutivo }}</span>
              </b-col>
            </b-row>

            
            <b-row class="my-1">
              <b-col sm = "2">
                <label>Corredor</label>
              </b-col>  
              <b-col sm = "2">
                <b-form  @submit.prevent="consulta_corredor()" > 
                  <b-input-group @change="consulta_corredor()">
                    <b-form-input type="number" v-model="datosFormulario.codCorredor"/>
                    <b-input-group-prepend class="input-group-append">
                        <b-button @click="buscarcorredor()" class="fa fa-search" variant="primary"></b-button>
                    </b-input-group-prepend>
                  </b-input-group>
                </b-form>
              </b-col>
              <b-col sm = "2">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.IdNacionCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
                <b-input-group>
                  <b-form-input type="text"  disabled v-model="datosFormulario.NombreCorred"/>
                </b-input-group>
              </b-col>
              <b-col sm="3">
              </b-col>
            </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Producto</label>
              </b-col>
              <b-col sm="2">
                  <b-form-select
                      :options="valProductos"
                      v-model="datosFormulario.producto">
                  </b-form-select>
              </b-col>
            </b-row>

            
            <b-row class="my-1">
              <b-col sm = "2">
                <label>Fecha Reporte</label>
              </b-col>  
              <b-col sm = "2">
                <b-form>
                  <b-input-group> 
                    <b-form-input 
                        type="text" 
                        disabled
                        v-model="datosFormulario.fecha"
                        >
                    </b-form-input>
                </b-input-group>
                </b-form>
              </b-col>

            
          </b-row>

            <b-row class="my-1">
              <b-col sm="2">
                <label>Ver</label>
              </b-col>
              
              <b-col sm="8"> 

              <b-form-group >
                <b-form-radio-group 
                  id="radio-group-1"
                  v-model="datosFormulario.estado"
                  name="radio-options">
                  <!-- Radios in the default slot will appear after any option generated radios -->
                  <b-form-radio value="ACT">Sólo Líneas Activas</b-form-radio>
                  <b-form-radio value="ULT">Últimos dos Años</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              </b-col>

            </b-row>

      
            
            <b-row class="mb-2">
              <b-col sm="2">
                <label>Incluir</label>
              </b-col>
              
              <b-col sm="5">
                <b-form-checkbox-group
                  v-model="selectedMon"
                  :options="ckdMoneda"
                  class="mb-3"
                  value-field="item"
                  text-field="name"
                  disabled-field="notEnabled"
                ></b-form-checkbox-group>
              </b-col>
              
            </b-row>


          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel" style="margin-left: 10px;"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>


        

        

      </b-col>
    </b-row>

    <b-modal
      title="Búsqueda de Corredor"
      scrollable
      cancel-title="Cerrar"
      class="modal-success"
      size="lg"
      v-model="modalCorredor"
      @cancel="modalCorredor = false"
      hide-footer
    >
      <b-row> 
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters3[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      <b-row>
      <b-col lg="12">             
        <div ref="refTable">
          <data-tables ref="refTable1"
            :data="data2"
            name="table"
            class="table-responsive"
            :current-page.sync="pagina"
            :table-props="tableProps2"
            :filters="filters3"
            :page-size="10"
            :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
            layout="table"
            >
          <el-table-column
            v-for="title in titles3"
            :min-width="title.minwidth" 
            :prop="title.prop"
            :label='title.label'
            :key="title.label"
            :align="title.align"
            sortable="custom"
            :formatter="formatter"
            name="table"
            class="table-responsive"
            >

            <template slot-scope="scope">  
              <div v-if="title.prop == 'corredor'">    
                <b-link type="text" v-if="scope.row.codcorredor > 1" @click="selecciona_corredor(scope.row.codcorredor,scope.row.corredor,scope.row.idnacion)">{{scope.row.corredor}}</b-link>
                  <p v-else >{{scope.row.corredor}}</p>
                  </div>
                    <p v-else>{{scope.row[title.prop]}}</p>
            </template>  

          </el-table-column>
          </data-tables>
        </div>
      </b-col>
    </b-row>
    </b-modal>  

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConCorredor  from "@/components/services/apiConCorredor";
import apiPorcAprLinGen from "@/components/services/apiPorcAprLinGen";
import apiBaseAsegurado from "@/components/services/apiBaseAsegurado";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import download from "downloadjs";
import Multiselect from "vue-multiselect";

import XLSX from "xlsx";

export default {
  name: "CostoVariableMinimo",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch,
  },
  data: function () {
    return {
      hasPoliza: false,
      exportar: false,
      modalCorredor : false,      
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715",
      },
      selectedCor: [],
      selectedMon:[],
      
      
      data: [],
      data2: [],
      nombreexcel: "CostoVariableMinimo",

      titles: [
        {
          prop: "asegurado",
          label: "Nombre Contratante",
          align: "left",
          minwidth: "250",
        },
        {
          prop: "poliza",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "expira",
          label: "E",
          align: "left",
          minwidth: "80",
        },
        {
          prop: "producto",
          label: "Producto",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "ejecutivo",
          label: "Ejecutivo",
          align: "left",
          minwidth: "100",
        },
        {
          prop: "asistente",
          label: "Asistente",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "corredor",
          label: "Corredor",
          align: "center",
          minwidth: "250",
        },
        {
          prop: "moneda",
          label: "Moneda Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "mtosol",
          label: "Monto Solicitado Mon Póliza",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "mtoapr",
          label: "Monto Aprobado Mon Póliza",
          align: "right",
          minwidth: "100",
        },
        {
          prop: "porapr",
          label: "% Aprobación",
          align: "center",
          minwidth: "100",
        },

      ],
      titles3: [
        {
          prop: "corredor",
          label: "Corredor",
          align: "left",
          minwidth:'250'
        },
        {
          prop: "codcorredor",
          label: "Código",
          align: "left",
          minwidth:'150'
        },
        {
          prop: "idnacion",
          label: "Id. Nacional",
          align: "center",
          minwidth:'120'
        }
      ],

      titlesDinamic: [],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              if (prop === 'vigencia_desde'){

                let elDate = new Date(row["vigencia_desde"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'vigencia_hasta'){
                let elDate = new Date(row["vigencia_hasta"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }

            })

          }
        }
      ],

      filters3: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
          
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      mostrarFechas: true,

      datosFormulario: {
          poliza:"",
          NombreAseg:"",
          IdNacionAse:"",
          ejecutivo:"",
          asistente:"",
          producto:"",
          NombreCorred:"",
          IdNacionCorred:"",
          codCorredor:"",
          estado:"",
          moneda:"",
          fecha:"",
          opcmoneda:""
      },

      datosFormularioModal: {
          ejecutivo:"",
          poliza:"",
          moneda:"",
          data: []
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},

      valEjecutivos: [],
      valAsistentes: [],
      valProductos: [],
      monedas: [],
      ckdMoneda:[],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "id",
      },
    };
  },
  components: {
    Datepicker,
    Multiselect,
  },
  methods: {
    cargarColumnasGrilla(){
      this.titlesDinamic = [];
      let arrMeses= ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

      let mesactual = moment().month();
      let mesinicial = mesactual;

      let arrAux = [];
        arrAux["prop"] = 'contratante';
        arrAux["label"] = 'Contratante';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "250";
        this.titlesDinamic.push(arrAux);

      arrAux = [];
        arrAux["prop"] = 'poliza';
        arrAux["label"] = 'Póliza';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "120";
        this.titlesDinamic.push(arrAux);

      arrAux = [];
        arrAux["prop"] = 'producto';
        arrAux["label"] = 'producto';
        arrAux["align"] = "left";
        arrAux["minwidth"] = "120";
        this.titlesDinamic.push(arrAux);

      for (let step = 0; step < 12; step++) {
        let mes = (mesinicial + step) > 11? (mesinicial + step - 12) : (mesinicial + step);
        let label = arrMeses[mes];
        let prop = 'mes_' + (step > 9? step : ('0' + step));

        let arrAux = [];
        arrAux["prop"] = prop;
        arrAux["label"] = label;
        arrAux["align"] = "right";
        arrAux["minwidth"] = "150";
        this.titlesDinamic.push(arrAux);
      }

      arrAux = [];
        arrAux["prop"] = 'total_ventas';
        arrAux["label"] = 'Total';
        arrAux["align"] = "right";
        arrAux["minwidth"] = "150";
        this.titlesDinamic.push(arrAux);
    },

    customButtonsForRow(row) {
          var botones = new Array();

          var obj = new Object();
            obj.tooltip = "Detalle";
            obj.id = 1;
            obj.name= row.prima_ventas;
            obj.icon = "fa fa-eraser";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                // this.detalle(row);
            }
            botones.push(obj);


          return botones;

    },

     selecciona_corredor(p_codcorredor, p_corredor, p_idnacion) {
       this.datosFormulario.codCorredor = p_codcorredor;
       this.datosFormulario.NombreCorred = p_corredor;
       this.datosFormulario.IdNacionCorred = p_idnacion;
       this.modalCorredor = false;
       
    },

    buscarcorredor: function(){

      
      this.$Progress.start();
      var p_email= this.$session.get("mail");
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      return apiConCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
            response.data = this.keysMinuscula(response.data); 
            this.data2 = response.data.res;
            this.modalCorredor = true;
            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    consulta_corredor: function(){
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      var p_corredor = this.datosFormulario.codCorredor == '' ? '0': this.datosFormulario.codCorredor;
      var p_email = this.$session.get("mail");
      console.log(p_corredor);
      
      // if ((p_corredor==0) || (p_corredor=="")){
      //     this.datosFormulario.IdNacionCorred = "";
      //     this.datosFormulario.NombreCorred ="";
      //     this.mensaje= "Ingrese SR Corredor.";
      //     this.variant="warning";
      //     this.showAlert();
      //      return false;
      // }
      return apiConCorredor
        .consulta_corredor(
          p_email, p_corredor
        ).then((response) => {
         
         response.data = this.keysMinuscula(response.data);
         
         var InfoCorredor = response.data.res;
         this.data2 = response.data.res;
         
         
         for (var i = 0; i < InfoCorredor.length; i++) {
            this.datosFormulario.IdNacionCorred = InfoCorredor[i]["idnacion"];
            this.datosFormulario.NombreCorred = InfoCorredor[i]["corredor"];
          }
        this.$Progress.finish();
        })
        .catch((error) => {
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },


    // detalle(row) {
    //   this.datosFormularioModal.poliza = row.poliza;
    //   this.datosFormularioModal.data = [];
    //   this.$Progress.start();
    //   return apiPorcAprLinGen
    //     .recuperar_CostoVariableMinimoDetalle(
    //       this.$session.get("mail"),
    //       this.$session.get("usuarioInterno"),
    //       row.poliza,
    //       this.datosFormulario.moneda,
    //       this.datosFormulario.ejecutivo)
    //     .then((response) => {
    //       this.cargarColumnasGrilla();

    //       response.data = this.keysMinuscula(response.data);
    //       this.datosFormularioModal.data = response.data.res;

    //       this.$Progress.finish();
    //       this.modalDetalle = true;
    //     })
    //     .catch((error) => {
    //       this.$Progress.finish();
    //       this.mensaje = error;
    //       this.variant = "danger";
    //       this.showAlert();
    //     });
    // },

    llenaArrayLista(data, valor, texto, isDate) {
      var arr = new Array();
      for (var i = 0; i < data.length; i++) {
        var obj = new Object();
        if (isDate) {
          obj.value = this.convierteFecha(data[i][valor]);
          obj.text = this.convierteFecha(data[i][texto]);
        } else {
          obj.value = data[i][valor].toString();
          obj.text = data[i][texto];
        }
        arr.push(obj);
      }
      return arr;
    },

    pre_insertar() {
      this.$Progress.start();
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.value = null;

      this.datosFormulario.poliza = "";
      this.datosFormulario.ejecutivo = "0";
      this.datosFormulario.asistente = "0";
      this.datosFormulario.codCorredor = "";
      this.datosFormulario.producto = "T";
      this.datosFormulario.estado = "ACT";
      this.datosFormulario.NombreAseg = "";
      this.datosFormulario.IdNacionAse = "";
      this.datosFormulario.NombreCorred = "";
      this.datosFormulario.IdNacionCorred = "";

      this.hasPoliza = false;

      return apiPorcAprLinGen
        .pre_insercion_lin_gen(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.fecha = response.data.args_out.fecharpt;
          

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == "s") {
            this.tieneAcceso = true;
          } else {
            this.tieneAcceso = false;
          }

          this.datosFormulario.ejecutivo = "0";
          this.datosFormulario.asistente = "0";
          this.datosFormulario.poliza = "";

          //Carga lista de ejecutivos
          var tiposEjecutivos = new Array();
          var objTodos = new Object();
          objTodos.value = "0";
          objTodos.text = "Todos";
          tiposEjecutivos.push(objTodos);

          var lista_tipos_ejecutivos = response.data.ejecutivo;
          for (var i = 0; i < lista_tipos_ejecutivos.length; i++) {
            var obj = new Object();
            obj.value = lista_tipos_ejecutivos[i]["usucodigo"];
            obj.text = lista_tipos_ejecutivos[i]["usunombre"];
            tiposEjecutivos.push(obj);
          }

          this.valEjecutivos = tiposEjecutivos;

          //Carga lista de asistente
          var tiposAsistentes = new Array();
          var objTodos = new Object();
          objTodos.value = "0";
          objTodos.text = "Todos";
          tiposAsistentes.push(objTodos);

          var lista_tipos_asistente = response.data.asistente;
          for (var i = 0; i < lista_tipos_asistente.length; i++) {
            var obj = new Object();
            obj.value = lista_tipos_asistente[i]["usucodigo"];
            obj.text = lista_tipos_asistente[i]["usunombre"];
            tiposAsistentes.push(obj);
          }

          this.valAsistentes = tiposAsistentes;

          //Carga lista de producto
          var tiposProducto = new Array();
          var objTodos = new Object();
          objTodos.value = "T";
          objTodos.text = "Todos";
          tiposProducto.push(objTodos);

          var lista_tipos_producto = response.data.producto;
          for (var i = 0; i < lista_tipos_producto.length; i++) {
            var obj = new Object();
            obj.value = lista_tipos_producto[i]["codigo"];
            obj.text = lista_tipos_producto[i]["descripcion"];
            tiposProducto.push(obj);
          }

          this.valProductos = tiposProducto; 
          
        console.log(process.env.VUE_APP_LOCALE);
        
        if (process.env.VUE_APP_LOCALE === 'es-cl'){
          this.ckdMoneda =  [
          { item:  'UF', name: 'Incluir monto en UF' },
          { item:  'US', name: 'Incluir monto en US' }
          ]
        } else if(process.env.VUE_APP_LOCALE === 'es-pe'){
          this.ckdMoneda =  [
          { item:  'US', name: 'Incluir monto en US' }
          ]
        } else if(process.env.VUE_APP_LOCALE === 'es-ar'){
          this.ckdMoneda =  [
          { item:  'US', name: 'Incluir monto en US' }
          ]

        }


          this.$Progress.finish();
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    buscar() {
      this.$Progress.start();
      this.exportar = false;
      var p_email = this.$session.get("mail");

      var p_poliza = this.datosFormulario.poliza == ""? "0" : this.datosFormulario.poliza;
      var p_ejecutivo = this.datosFormulario.ejecutivo == "Todos"? "0" : this.datosFormulario.ejecutivo;
      var p_asistente = this.datosFormulario.asistente == "Todos"? "0" : this.datosFormulario.asistente;
      var p_producto = this.datosFormulario.producto == ""? "0" : this.datosFormulario.producto;
      var p_corredor = this.datosFormulario.codCorredor == ""? "0" : this.datosFormulario.codCorredor;
      var p_estado = this.datosFormulario.estado == ""? "ULT" : this.datosFormulario.estado;    
      
      this.crearNotificacion(
                    "Información",
                    "El listado de la consulta será enviado a su correo electrónico",
                    "success"
                  );
                  this.$Progress.finish();

      return apiPorcAprLinGen
        .recuperar_lin_gen(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          p_poliza,
          p_ejecutivo,
          p_asistente,
          p_producto,
          p_corredor,
          p_estado
          )
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          // this.data = response.data.res;
          
        })
        .catch((error) => {
          this.$Progress.finish();
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
        });
    },

    formatter(row, column) {
      if ((column.property == "vigencia_desde" || column.property == "vigencia_hasta") && row[column.property]) {
        return this.configurarFechaLat(
          this.convierteFecha(row[column.property])
        );
      } else if ((column.property == "prima_ventas" || column.property == "mes_00" || column.property == "mes_01" || column.property == "mes_02" || column.property == "mes_03" || column.property == "mes_04" || column.property == "mes_05" || column.property == "mes_06"  || column.property == "mes_07" || column.property == "mes_08" || column.property == "mes_09" || column.property == "mes_10" || column.property == "mes_11" || column.property == "total_ventas") && row[column.property]) {
        if (row[column.property] == -1 || row[column.property] == "-1"){
          return "N/A";
        }
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else if (column.property == "costo_variable_minimo" && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0");
        }
      } else {
        return row[column.property];
      }
    },

    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";


      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo +="<td class=xl679618 style='border-left:none;" + xl679618 +"'>Monto Solicitado en UF</td>\n";
      cuerpo +="<td class=xl679618 style='border-left:none;" + xl679618 +"'>Monto Aprobado en UF</td>\n";
      cuerpo +="<td class=xl679618 style='border-left:none;" + xl679618 +"'>Monto Solicitado en US</td>\n";
      cuerpo +="<td class=xl679618 style='border-left:none;" + xl679618 +"'>Monto Aprobado en US</td>\n";
      
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.data) {

        if(this.data[key]["asegurado"] == undefined){
          this.data[key]["asegurado"] = "";
        }
        if(this.data[key]["poliza"] == undefined){
          this.data[key]["poliza"] = "";
        }
        if(this.data[key]["expira"] == undefined){
          this.data[key]["expira"] = "";
        }
        if(this.data[key]["producto"] == undefined){
          this.data[key]["producto"] = "";
        }
        if(this.data[key]["ejecutivo"] == undefined){
          this.data[key]["ejecutivo"] = "";
        }
        if(this.data[key]["asistente"] == undefined){
          this.data[key]["asistente"] = "";
        }
        if(this.data[key]["corredor"] == undefined){
          this.data[key]["corredor"] = "";
        }
        if(this.data[key]["moneda"] == undefined){
          this.data[key]["moneda"] = "";
        }
        if(this.data[key]["mtosol"] == undefined){
          this.data[key]["mtosol"] = "";
        }
        if(this.data[key]["mtoapr"] == undefined){
          this.data[key]["mtoapr"] = "";
        }
        if(this.data[key]["porapr"] == undefined){
          this.data[key]["porapr"] = "";
        }
        if(this.data[key]["mtosol_uf"] == undefined){
          this.data[key]["mtosol_uf"] = "";
        }
        if(this.data[key]["mtoapr_uf"] == undefined){
          this.data[key]["mtoapr_uf"] = "";
        }
        if(this.data[key]["mtosol_us"] == undefined){
          this.data[key]["mtosol_us"] = "";
        }
        if(this.data[key]["mtoapr_us"] == undefined){
          this.data[key]["mtoapr_us"] = "";
        }


        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asegurado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["expira"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["ejecutivo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asistente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["corredor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtosol"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtoapr"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["porapr"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtosol_uf"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtoapr_uf"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtosol_us"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["mtoapr_us"]).format("0,0.00") + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    descargarExcelModal: function () {
      var cuerpo = "";
      var columnas = this.titlesDinamic;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      /* cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >CostoVariableMinimo</td>\n";
      cuerpo += "</tr>\n";*/

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";

      //Data bloque 1
      for (var key in this.datosFormularioModal.data) {
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["contratante"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.datosFormularioModal.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_00"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_00"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_01"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_01"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_02"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_02"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_03"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_03"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_04"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_04"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_05"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_05"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_06"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_06"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_07"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_07"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_08"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_08"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_09"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_09"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_10"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_10"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["mes_11"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["mes_11"]).format("0,0.00")) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.datosFormularioModal.data[key]["total_ventas"] == -1? 'N/A' : this.$numeral(this.datosFormularioModal.data[key]["total_ventas"]).format("0,0.00")) + "</td>\n";

        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export: async function (data, filename) {
      if (typeof this.beforeFinish === "function") await this.beforeFinish();
      download(data, filename, "application/vnd.ms-excel");
    },

    convierteFecha(fechaEntrada) {
      if (fechaEntrada != undefined && fechaEntrada.length != 0) {
        var fecha = new Date(fechaEntrada);

        var dia = ("0" + fecha.getUTCDate()).slice(-2);
        var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2);
        var año = fecha.getUTCFullYear();

        fecha = dia + "-" + mes + "-" + año;

        return fecha;
      } else {
        return fechaEntrada;
      }
    },

    consulta_poliza: function () {
      this.$Progress.start();
      this.mensajeValidacionCampo = {};
      this.hasPoliza = false;

      this.datosFormulario.ejecutivo == "Todos"? "0" : this.datosFormulario.ejecutivo;
      this.datosFormulario.poliza == "" ? "" : this.datosFormulario.poliza;
      // this.datosFormulario.moneda == "" ? "" : this.datosFormulario.moneda;

      var p_email = this.$session.get("mail");
      var p_ejecutivo = this.datosFormulario.ejecutivo;
      var p_poliza = this.datosFormulario.poliza;

      if (p_ejecutivo == "") {
        p_ejecutivo = "0";
      }

      return apiPorcAprLinGen
        .consulta_poliza(p_email, p_ejecutivo, p_poliza)
        .then((response) => {
          response.data = this.keysMinuscula(response.data);
          
          var Listapoliza = response.data.res;
          for (var i = 0; i < Listapoliza.length; i++) {
            this.datosFormulario.poliza = Listapoliza[i]["marpoliza"];
            this.datosFormulario.NombreAseg = Listapoliza[i]["nomcontratante"];
            this.datosFormulario.IdNacionAse  = Listapoliza[i]["peridnacion"];
            this.datosFormulario.ejecutivo = Listapoliza[i]["ejecutivo"];
            this.datosFormulario.asistente = Listapoliza[i]["asistente"];
            this.datosFormulario.codCorredor = Listapoliza[i]["marcorredor"];
            this.hasPoliza = true;
          }
          this.$Progress.finish();
          // this.consulta_contratante();
          this.consulta_corredor();  
          // this.buscar();  
        })
        .catch((error) => {
          this.mensaje = error;
          this.variant = "danger";
          this.showAlert();
          this.$Progress.finish();
        });
    },


  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    //this.buscar();
  },

  watch: {
    pagina: function (nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.card-header {
  background-color: #00a7d4;
  color: #fff;
}

.multiselect__tag {
  background: #20a8d8 !important;
}
.multiselect__option--highlight:after {
  background: #20a8d8 !important;
}

.multiselect__option--highlight {
  background: #20a8d8 !important;
}
.multiselect__tags {
  border-radius: 0px !important;
  min-height: 70px !important;
}
/*
.el-button {
  background: #00a7d4;
}*/
</style>

